import React from 'react';
import { Props } from '../../types';
import { Container } from '../../styles';
import { orange, blue, green, cyan, lemon, yellow } from '../../index';

const Status: React.FC<Props> = ({ acronym }) => {
  let text = React.useRef('');
  let color = React.useRef('');

  switch (acronym) {
    case 'SL':
      text.current = 'Solicitado';
      color.current = blue;
      break;
    case 'AA':
      text.current = 'Aguardando agendamento';
      color.current = lemon;
      break;
    case 'AG':
      text.current = 'Agendado';
      color.current = orange;
      break;
    case 'NE':
      text.current = 'Nota emitida';
      color.current = cyan;
      break;
    case 'EX':
      text.current = 'Expedido';
      color.current = green;
      break;
    case 'AC':
      text.current = 'Agendamento Crossdock';
      color.current = yellow;
      break;
    default:
      color.current = '#777';
      text.current = 'Sem informações de status';
      break;
  }

  return (
    <Container data-cy="statusAtendimento" color={color.current}>
      {text.current}
    </Container>
  );
};

export default Status;
